import type { SelectProps as RCASelectProps } from 'react-aria-components'
import { Select as RACSelect } from 'react-aria-components'

export interface SelectProps extends RCASelectProps<{}> {}

export default function Select(props: SelectProps) {
  return <RACSelect {...props}>{props.children}</RACSelect>
}
